import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useChat() {
    const api = useApi();
    const state = useAppState();
    function getLastChatMessage(onSuccess = null) {
        api.GET("/Chats/Messages?customerId=" + state.customer.id, (result) => {
            if (onSuccess)
                onSuccess(result);
        }, false);
    }
    function pollForChatResponse(lastMessageId, onSuccess = null) {
        setTimeout(() => {
            getLastChatMessage((lastMessage) => {
                if (lastMessage && lastMessage.length > 0 && lastMessage[0].id != lastMessageId && lastMessage[0].direction == "OUT") {
                    if (onSuccess) {
                        onSuccess(lastMessage[0]);
                    }
                }
                else {
                    pollForChatResponse(lastMessageId, onSuccess);
                }
            });
        }, 5000);
    }
    function sendChatMessage(message, onSuccess = null, allowRetry = true) {
        let lastMessageId = null;
        getLastChatMessage((lastMessage) => {
            if (lastMessage && lastMessage.length > 0) {
                lastMessageId = lastMessage[0].id;
            }
            getHttpInstance().post(getApiConfig().api + "/Chats/ChatRequests?customerID=" + state.customer.id, {
                "body": message
            })
                .then((result) => {
                if (onSuccess) {
                    onSuccess(result.data);
                }
            })
                .catch((result) => {
                console.log(result, 'ERROR CAUGHT');
                if (result.response && result.response.status == 401) {
                    api.refreshLogin(() => {
                        sendChatMessage(message, onSuccess);
                    });
                }
                else if (result.response && result.response.status == 503) {
                    if (allowRetry) {
                        if (onSuccess)
                            onSuccess({ body: "I'm still working on that 💭💭 Just a moment!", keepThinking: true });
                        pollForChatResponse(lastMessageId, onSuccess);
                    }
                    else {
                        if (onSuccess)
                            onSuccess({ body: "Sorry, I can't help you with that right now." });
                    }
                }
                else if (result.code == 'ERR_NETWORK') {
                    if (allowRetry) {
                        if (onSuccess)
                            onSuccess({ body: "I'm still working on that 💭💭 Just a moment!", keepThinking: true });
                        pollForChatResponse(lastMessageId, onSuccess);
                    }
                    else {
                        if (onSuccess)
                            onSuccess({ body: "Sorry, I can't help you with that right now." });
                    }
                }
            });
        });
    }
    function sendSessionlessChatMessage(message, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Chats/ChatRequestsEx", {
            "body": message
        })
            .then((result) => {
            if (onSuccess) {
                onSuccess(result.data);
            }
        });
    }
    return {
        getLastChatMessage,
        pollForChatResponse,
        sendChatMessage,
        sendSessionlessChatMessage,
    };
}
